
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import { GetServerSideProps } from 'next';
import { getReferralLandingData } from '@/api/growth';
import { addParameterToUrl, buildUrlWithOrigin, getSafeQueryValue, removeUrlParameters } from '@/utils/url';
import { setCookie } from '@/utils/cookie';
import { getTrackSession } from '@/api/tracking';
import Constants from '@/constants/const';
import { getAssetsCdnConfig } from '@weee-fe/module';
import { getHttpReqAwareProps } from '@/utils/http-req-aware-helper';

import InviteeHeader from '@/components/referral/InviteeHeader';
import InviteeHero from '@/components/referral/InviteeHero';
import useImpressionT2 from '@/tracks/useImpressionT2';
import DownloadAppModule from '@/components/referral/DownloadAppModule';
import MarketInfo from '@/components/referral/MarketInfo';
import DescriptionModule from '@/components/referral/DescriptionModule';
import InviteeFooter from '@/components/referral/InviteeFooter';
import { isMobileBrowser } from '@/utils/common/device';
import Layout from '@/layouts/simple';
import { getLoginState } from '@/utils/common/user';
import { useRouter } from 'next/router';
import { getABExperimentResult } from '@/api/data';
interface InviteeLandingProps {
  data?: any;
  id?: string;
  isMobile?: boolean;
  showNewLoginV3?: boolean;
  [key: string]: any;
}

export default function InviteeLanding(props: InviteeLandingProps) {
  const { data, id, isMobile, isLogin, showNewLoginV3 } = props;
  const router = useRouter();
  const { pageSectionImpression } = useImpressionT2();

  const [showBack, setShowBack] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const handleNextStep = (step: number) => {
    setCurrentStep(step);
    currentStep === 0 && setShowBack(true);
  };

  const handleStepBack = (show: boolean) => {
    setShowBack(show);
    setCurrentStep(0);
    const link_url = removeUrlParameters(window.location.href, ['redirect_url']);
    router.replace(link_url);
  };

  useEffect(() => {
    pageSectionImpression({
      mod_nm: 'signup_step',
      ctx: {
        step: showBack ? 2 : 1
      }
    });
  }, [showBack]);

  useEffect(() => {
    const baseLink = window.location.href;
    if (currentStep === 1) {
      const link_url = addParameterToUrl(baseLink, 'redirect_url', encodeURIComponent(data?.success_url));
      router.replace(link_url);
    }
    if (currentStep === 0) {
      const link_url = removeUrlParameters(baseLink, ['redirect_url']);
      router.replace(link_url);
    }
  }, [currentStep, data?.success_url]);

  return (
    <Layout
      blockStreamlinedHeader
      headerWrapClassName="bg-surface-100-bg"
      header={<InviteeHeader showBack={showBack} onShowBack={() => handleStepBack(false)} />}
      contentClassName="bg-surface-100-bg box-border min-h-[calc(100vh-48px)]">
      {!!props?.data?.meta_properties && (
        <Head>
          <meta name="format-detection" content="telephone=no" />
          <meta
            property="fb:app_id"
            content={`${process.env.WEEE_FACEBOOK_APPID || process.env.NEXT_PUBLIC_WEEE_FACEBOOK_APPID}`}
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={props?.data?.meta_properties?.fb_url} />
          <meta property="og:title" content={props?.data?.meta_properties?.fb_title} />
          <meta property="og:description" content={props?.data?.meta_properties?.fb_description} />
          <meta property="og:image" content={`${props?.data?.meta_properties?.fb_image}`} />
          <meta property="og:image:alt" content={props?.data?.meta_properties?.fb_title} />
        </Head>
      )}
      <div className="w-full h-full bg-surface-100-bg">
        <InviteeHero
          data={data}
          currentStep={currentStep}
          handleNextStep={handleNextStep}
          isMobile={isMobile}
          isLogin={isLogin}
          showNewLoginV3={showNewLoginV3}
        />
        <DownloadAppModule />
        <MarketInfo isMobile={isMobile} />
        <DescriptionModule />
        <InviteeFooter />
      </div>
    </Layout>
  );
}

const refreshSession = async (source: string, ctx?) => {
  const url = encodeURIComponent('/');
  return getTrackSession(source, url, { ctx }).then(({ object }) => {
    setCookie(Constants.WEEE_SESSION_TOKEN, object?.weee_session_token, ctx, {
      maxAge: Constants.WEEE_SESSION_TOKEN_MAX_AGE
    });
  });
};

 const _getServerSideProps: GetServerSideProps = async ctx => {
  const { locale, query } = ctx;
  const referralId = getSafeQueryValue((query?.referral_id ?? '') as string);
  if (!referralId) {
    return {
      redirect: {
        destination: buildUrlWithOrigin(`/${locale}`),
        permanent: false
      }
    };
  }

  try {
    //do ab experiment id:988
    const abExperimentRes = await getABExperimentResult(
      {
        experiment_id: 988
      },
      { ctx }
    );
    const res = await getReferralLandingData(
      {
        referrer_id: referralId
      },
      { ctx }
    );
    if (!res?.result) {
      return {
        redirect: {
          destination: buildUrlWithOrigin(`/${locale}`),
          permanent: false
        }
      };
    }
    if (res?.object?.redirect_url) {
      return {
        redirect: {
          destination: res?.object?.redirect_url,
          permanent: false
        }
      };
    }

    return {
      props: {
        showNewLoginV3: abExperimentRes?.object?.routed_group_variation === '1',
        data: res?.object,
        id: referralId,
        isMobile: isMobileBrowser(ctx),
        isLogin: getLoginState(ctx),
        ...getAssetsCdnConfig(ctx),
        ...getHttpReqAwareProps(ctx)
      }
    };
  } catch (error) {}
};


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/account/referral/landing/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  